import axios from 'axios';
import { getAuthToken, getRefreshToken, getSocketID, login } from 'src/utils/common';

const getRefreshAccessToken = () =>
  callApiNew<TokensResponse>({
    endpoint: `/token/refresh`,
    method: 'POST',
    body: { refresh: getRefreshToken() },
  });

export const INVALID_TOKEN = 'token_not_valid';

export const callApiNew = async <Response>(apiConfig: CallAPIConfig): Promise<Response> => {
  const initialConfigObject: Partial<CallAPIConfig> = {
    method: 'GET',
    authenticated: true,
    params: {},
    body: {},
    headers: {},
  };

  const { authenticated, endpoint, method, headers, params, body } = {
    ...initialConfigObject,
    ...apiConfig,
  };

  const mandatoryHeaders = {
    'Content-Type': 'application/json',
    Authorization: '',
  };
  const token = getAuthToken();
  if (authenticated) {
    if (token) {
      mandatoryHeaders.Authorization = `Bearer ${token}`;
    } else {
      throw new Error('No token saved!');
    }
  }

  const socketId = getSocketID();
  const socketIdHeader = socketId ? { 'socket-id': socketId } : {};

  const requestHeaders = {
    ...mandatoryHeaders,
    ...socketIdHeader,
    ...headers,
  };

  const config = {
    method,
    params,
    headers: requestHeaders,
    data: body,
    url: process.env.REACT_APP_SERVER_URL + endpoint,
  };

  axios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
      if (error.response.status === 401 && error.response.data.code === INVALID_TOKEN && !originalRequest.retry) {
        originalRequest.retry = true;
        const resp = await getRefreshAccessToken();
        login(resp.access, resp.refresh);
        originalRequest.headers.Authorization = 'Bearer ' + resp.access;

        return axios(originalRequest);
      }

      return Promise.reject(error);
    }
  );

  return axios
    .request(config)
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
